import { z } from 'zod';

export const projectReadonlySchema = z.object({
  readonly: z.boolean(),
});
